import { BaseApi } from "../BaseApi";

let API: BaseApi | null = null;

function getApiInstance(): BaseApi {
  if (!API) {
    API = new BaseApi();
  }
  return API;
}

export function getUserSalariesList(month?: string) {
  try {
    const qs = month ? `?month=${encodeURIComponent(month)}` : "";
    return getApiInstance().get(`user-salaries/list${qs}`);
  } catch (error) {
    console.error("Error fetching user salaries:", error);
  }
}

export function getAvailableUsersForSalary() {
  try {
    return getApiInstance().get("user-salaries/available-users");
  } catch (error) {
    console.error("Error fetching available users:", error);
  }
}

export function setUserSalary(params: { user: string; amount: number }) {
  try {
    return getApiInstance().post("user-salaries", params);
  } catch (error) {
    console.error("Error setting user salary:", error);
  }
}

export function deleteUserSalary(userId: string) {
  try {
    return getApiInstance().axiosInstance.delete(`user-salaries/${userId}`, { timeout: 10000 });
  } catch (error) {
    console.error("Error deleting user salary:", error);
  }
}

export function getSalaryAdvancesList(month?: string) {
  try {
    const qs = month ? `?month=${encodeURIComponent(month)}` : "";
    return getApiInstance().get(`salary-advances/list${qs}`);
  } catch (error) {
    console.error("Error fetching salary advances:", error);
  }
}

export function createSalaryAdvance(params: {
  user: string;
  amount: number;
  advanceDate?: string;
  status?: "pending" | "paid";
  comment?: string;
}) {
  try {
    return getApiInstance().post("salary-advances", params);
  } catch (error) {
    console.error("Error creating salary advance:", error);
  }
}

export function updateSalaryAdvanceStatusApi(params: {
  id: string;
  status: "pending" | "paid";
}) {
  return getApiInstance().axiosInstance.put(
    `salary-advances/${params.id}/status`,
    { status: params.status },
    { timeout: 10000 }
  );
}
